import { useQuery } from "react-query";
import { getSquareAuthStatus } from "../../../services/marketplace";

export const useGetSquareAuthStatus = () => {
  return useQuery(
    ["getSquareAuthStatus"],
    () => getSquareAuthStatus().then((res) => res?.data?.data),
    { staleTime: Infinity },
  );
};
